/*

class to generate a schedule

https://www.hl7.org/fhir/schedule.html

{
  "state" : "<code>" // active || pending || archive || delete
  "userType" : "<code>", // orgAdmin || providerAP || providerLP || patient
  "userId" : "<String>"
  "scheduleId" : "<String>"
  "serviceCategory" : [{ code }], // High-level category
  "serviceType" : [{ code }], // Specific service
  "specialty" : [{ code }], // Type of specialty needed
  "actor" : [{ Reference(Patient|Practitioner|PractitionerRole|RelatedPerson|Device|HealthcareService|Location) }], // R!  Resource(s) that availability information is being provided for
  "planningHorizon" : { Period }, // Period of time covered by schedule
  "comment" : "<string>" // Comments on availability
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { STATES, USER_TYPES } = require('@bcm/constants');
const { joiValidateObj, identifiers } = require('../datastructComponents');
const { DataTableBase } = require('./base.class');
const { codeSchema } = require('./code.class');

// Create schema
const schema = {
  identifier: Joi.any().optional(),
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  userType: Joi.string().valid( ...Object.keys(USER_TYPES) ).required(),
  userId: Joi.string().required(),
  scheduleId: Joi.string().required(),
  actor: Joi.array().items( Joi.string().required() ).required(),
  planningHorizonPeriodStart: Joi.string().optional(),
  planningHorizonPeriodEnd: Joi.string().optional(),
  serviceCategory:  Joi.array().items(codeSchema).optional(),
  serviceType: Joi.array().items(codeSchema).optional(),
  specialty: Joi.array().items(codeSchema).optional(),
  comment: Joi.string().optional(),
};

// Define class
class Schedule extends DataTableBase {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    super (
      identifiers.schedule.buildPk(obj.userId),
      identifiers.schedule.buildSk(obj.state, obj.userType, obj.userId, obj.scheduleId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Schedule = Schedule;
exports.scheduleSchema = schema;